angular.module('nv.components.tooltip').controller('TooltipCtrl', tooltipCtrl);

function tooltipCtrl() {
  let self = this;

  self.displayTooltip = false;
}
